module.exports = __webpack_public_path__ + "img/intro.8a9d36bf.jpg";